import { Text, type TextProps } from '@mantine/core'

import { type UNSAFE_any, type CoreBookingProduct } from '@flecto/types'

import { useTaxesInfo } from '../../../taxes'
import {
  translateLabelFormated,
  usePricingTierLabel,
} from '../../hooks/usePricingTierLabel'

export type TextBookingProductPricingRuleProps = TextProps & {
  bookingProduct?: CoreBookingProduct
  quotePreviewBookingProduct?: UNSAFE_any
  withTax?: boolean
  withPrice?: boolean
  withFormatPrice?: boolean
}

export function TextBookingProductPricingRule({
  bookingProduct,
  quotePreviewBookingProduct,
  withPrice = false,
  withFormatPrice = true,
  withTax,
  ...props
}: TextBookingProductPricingRuleProps) {
  const { userSettingShowPricesWithTaxes } = useTaxesInfo()

  return (
    <Text {...props}>
      {translateLabelFormated(
        usePricingTierLabel({
          tiers:
            bookingProduct?.pricing_tiers ||
            quotePreviewBookingProduct?.pricing_tiers,
          withFormatPrice,
          withPrice,
          withTax:
            typeof withTax === 'boolean'
              ? withTax
              : userSettingShowPricesWithTaxes,
        }) || ''
      )}
    </Text>
  )
}
